<div class="center">
  <button mat-raised-button (click)="sbRef.dismissWithAction()" class="cancel-button cancel-countdown">
    <div class="spinner-container">
      <mat-progress-spinner
        [diameter]="32"
        [mode]="'determinate'"
        [value]="(100 / defaultTime) * runningTimer"
      >
      </mat-progress-spinner>
      <span>{{ runningTimer }}</span>
    </div>
    <span>Alerting...</span>
    <div class="spinner-action">
      <mat-icon>call_end</mat-icon> CANCEL
    </div>
  </button>
</div>
